import { Image, StyleSheet, TouchableOpacity, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { Svg } from "assets/svg";
import Input from "components/Input";
import VText from "components/VText";

const ChatInputComponent = ({
    inputValue,
    setInputValue,
    handleSendMessage,
    promentCount,
    isMicRecording,
    isTranscript,
    setIsTranscript,
    handleMicPress,
    imageUrl,
    setImageUrl,
    handleCameraPress,
    handleDownloadApp,
    setIsTyping,
    isFromModal = false,
}) => {
    return (
        <>
            <View style={{ flexDirection: "row" }}>
                <View
                    style={{
                        flexDirection: "row",
                        width: wp(890),
                        height: hp(46),
                        marginVertical: spV(20),
                        justifyContent: "start",
                        alignItems: "center",
                        paddingHorizontal: spH(10),
                        borderWidth: 1,
                        borderColor: "#E7E7E7",
                        backgroundColor: promentCount < 3 ? "white" : "#F5F5F5",
                    }}
                >
                    <Image accessibilityLabel="AI Icon" source={Svg.aiIcon} style={{ width: wp(20), height: hp(20) }} />
                    <Input
                        enableEnter={promentCount < 3}
                        disableFullscreenUI={true}
                        onPressEnter={handleSendMessage}
                        containerStyle={{ flex: 1 }}
                        inputContainerStyle={{
                            height: "100%",
                            color: "black",
                            fontSize: fp(18),
                            paddingHorizontal: spH(10),
                            border: "none",
                        }}
                        placeholderTextColor="#2124274D"
                        placeholder={
                            promentCount < 3
                                ? isMicRecording
                                    ? "Listening..."
                                    : "Send a message "
                                : "You already asked three prompts on our desktop version."
                        }
                        value={inputValue}
                        editable={promentCount < 3}
                        onChangeText={(text) => {
                            if (promentCount < 3) {
                                setInputValue(text);
                                if (text.length > 0) {
                                    setIsTyping(false);
                                }
                            }
                        }}
                    />
                    {isTranscript && (
                        <TouchableOpacity
                            style={{
                                position: "absolute",
                                justifyContent: "center",
                                alignItems: "center",
                                right: spH(10),
                                top: spV(10),
                            }}
                            onPress={() => {
                                setIsTranscript(false);
                                setInputValue("");
                            }}
                        >
                            <Image
                                accessibilityLabel="Close Button"
                                source={Svg.closeButtonDark}
                                style={{ width: wp(20), height: hp(20) }}
                            />
                        </TouchableOpacity>
                    )}
                </View>

                <TouchableOpacity
                    disabled={promentCount >= 3}
                    onPress={handleMicPress}
                    style={{ width: wp(30), height: "100%", marginLeft: spH(15), marginTop: spV(35) }}
                >
                    <Image
                        source={Svg.micIcon}
                        accessibilityLabel="Mic Icon"
                        style={{
                            width: wp(20),
                            height: hp(20),
                            tintColor: promentCount >= 3 ? "#888888" : isMicRecording ? "#888888" : null,
                        }}
                    />
                </TouchableOpacity>

                {imageUrl ? (
                    <View style={{ marginTop: spV(-25) }}>
                        <TouchableOpacity
                            style={{ position: "relative", left: spH(60), top: spV(10), zIndex: 1000 }}
                            onPress={() => setImageUrl("")}
                        >
                            <Image
                                accessibilityLabel="Close Icon"
                                source={Svg.closeIcon}
                                style={{ width: wp(22), height: hp(22) }}
                            />
                        </TouchableOpacity>
                        <Image
                            accessibilityLabel="Image"
                            source={{ uri: imageUrl }}
                            style={{ width: wp(70), height: hp(100) }}
                        />
                    </View>
                ) : (
                    <TouchableOpacity
                        disabled={promentCount >= 3}
                        onPress={handleCameraPress}
                        style={{ width: wp(30), height: "100%", marginLeft: spH(5), marginTop: spV(35) }}
                    >
                        <Image
                            source={Svg.cameraIcon}
                            accessibilityLabel="Camera Icon"
                            style={{
                                width: wp(20),
                                height: hp(20),
                                tintColor: promentCount >= 3 ? "#888888" : null,
                            }}
                        />
                    </TouchableOpacity>
                )}

                <TouchableOpacity
                    onPress={handleSendMessage}
                    style={{
                        width: wp(30),
                        height: "100%",
                        marginLeft: spH(15),
                        marginTop: spV(28),
                        opacity: imageUrl || inputValue ? 1 : 0,
                    }}
                >
                    <Image
                        accessibilityLabel="Send Button"
                        source={Svg.sendButton}
                        style={{ width: wp(35), height: hp(35) }}
                    />
                </TouchableOpacity>
            </View>

            <View style={{ alignItems: "center", marginBottom: isFromModal ? spV(1) : spV(20) }}>
                {promentCount < 3 && (
                    <VText style={{ fontSize: fp(16), fontWeight: "300" }}>
                        You can ask three prompts on our desktop version.
                    </VText>
                )}
                <VText style={{ fontSize: fp(16), fontWeight: "300" }}>
                    To continue the conversation and unlock more features{" "}
                    <VText
                        onPress={handleDownloadApp}
                        style={{ textDecorationLine: "underline", fontSize: fp(16), fontWeight: "300" }}
                    >
                        Download the Vêtir app.
                    </VText>
                </VText>
            </View>
        </>
    );
};

const styles = StyleSheet.create({
    // Add any styles if needed
});

export default ChatInputComponent;
// This component is a chat input field with a microphone and camera button.
